export function getCurrency(cartContents) {

  let currency = '';
  if (cartContents) {
    const cartCurrency = cartContents.meta.sale_cur;

    switch (cartCurrency) {
      case "EUR":
        currency = "€";
        break;
      case "AUD":
        currency = "A$";
        break;
      case "USD":
          currency = "$";
          break;
      default:
        currency = "£";
    }
  }
  return currency;
}
